import $http from "../../axios";import {Notification, MessageBox} from 'element-ui';

export async function fetchBranchOffices({commit, state}) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
            commit('BranchOfficeError', error.message)
        })
}
export async function fetchLines({ dispatch, state, rootState, commit }) {
        await dispatch("lines/fetchLines",
            { params: { paginate: false, only_lines_unlocked_b2b: 1 } },
            { root: true }
        );
        commit("setLines", rootState.lines.lines);
}
export async function fetchBrand({ dispatch, state, rootState, commit },params) {
    await dispatch("brands/fetchBrands",
        {params: params },
        { root: true });
    commit("setBrands", rootState.brands.brands);
}
export async function fetchMinMaxReport({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/reporte-maximos-minimos',{params : state.params}).then((response) => {
            state.loading.module = false;
            commit('setReportMinMax', response.data)
        })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/report-max-min/actions.js